import * as React from "react"

// Styles
import "../../styles/faq/faq_section_questions.scss"

// The questions and answers
const items = [
    {
        q: "Snow tubes? Why make a game about snow tubes?",
        a: <>
            <p>
                Because Ski and Snowboard games are soooo overdone! At this point, it’s not even funny anymore!
            </p>
            <p>
                On a more serious note, some of my earliest childhood memories of playing video games are of a winter sports classic called <em>“Ski or Die”</em>. It had this game mode called <em>“Inner Tube Trash”</em>, where you controlled a fat and fun, colorful snow tube. And oh boy, I was obsessed!
            </p>
            <p>
                As these things go, some twenty or so years later, I suddenly woke up one morning and realised: <em>“Hey, I could make a game like that!”</em>
            </p>
        </>
    },
    {
        q: "I’ve heard of regular snow tubes. But what the heck is a “super” snow tube?",
        a: <>
            <p>
                Ah yes, a very common question, often based in misconception.
            </p>
            <p>
                Right, here we go... so as I was adding more and more levels to the game, I kept getting these comments from those super helpful kids telling me: <em>“But Ben, snow tubes only go on snow!”</em> You know... those smarty pants know it alls who like to remind the teacher there was homework? Yeah... so helpful.
            </p>
            <p>
                Anyway, turns out they weren’t so smart after all... Because you see... Ain’t nobody riding no plain old, boring, regular snow tubes in my game! Instead, we are dealing with “super” snow tubes. And super snow tubes can go on any terrain; snow, ice, water, grass, sand, you name it!
            </p>
            <p>
                It’s all right there in the game’s title. It's not called "Regular Snow Tubes", is it? I am telling you... kids these days.. quick to run their mouth, but can barely read anymore!
            </p>
        </>
    },
    {
        q: "What engine and tools did you use to make this game?",
        a: <>
            <p>
                The game engine used for Super Snow Tubes is <strong>Unity</strong> with the C# programming language. Notable packages include Cinemachine and Lean Tween. Nothing special, really.
            </p>
            <p>
                For pixel art, I of course use <strong>Aseprite</strong>. Someone once told me there were “other pixel art programs” out there... Yeah right, good one!
            </p>
            <p>
                For UI/UX design, I use <strong>Figma</strong>, which IMO is the best of those types of tools, highly recommended!
            </p>
            <p>
                For planning, task management and the like, I use a combination of <strong>Trello</strong> and <strong>Milanote</strong> - the only tool subscription I’ve ever come across that is actually worth paying for. (Hey Milanote, wanna sponsor me?)
            </p>
            <p>
                This website was built in <strong>Gatsby</strong>, which is a static site generator for React, which is a JavaScript library for building user interfaces. It creates pages that are lightning fast and have fantastic SEO.
            </p>
        </>
    },
    {
        q: "How long did it take you to make this game?",
        a: <>
            <p>
                Way, way, way too long! That’s why you better buy it, so that I can at least make some of that money back. And who knows, if it sells well, maybe I can afford two portions of microwave noodles a day. That’d be the dream!
            </p>
            <p>
                Jokes aside, somewhere in the order of three years, part time, on and off. Truth be told, the game and I have a bit of a “Ross and Rachel” thing going on. And just to be clear... that one time, when I worked on that other game... that was while we were on a break!
            </p>
            <p>
                PS: It would of course have gone a lot faster, if I hadn’t pivotted half a dozen times and spent weeks working on ideas that ultimately got thrown out. Scope creep is real, kids, you gotta watch out for that!
            </p>
        </>
    },
    {
        q: "Who created the game’s extra catchy soundtrack?",
        a: <>
            <p>
                The super happy, extra bouncy, ultra catchy soundtrack for Super Snow Tubes was composed by <a href="https://www.kashdanmusic.com/" target="_blank" rel="noreferrer">Joshua Kashdan</a>. It contains over 15 original tracks, with earworms guaranteed!
            </p>

            <p>
                If you’re looking for a composer, defnitely check out Josh, he rawks!
            </p>
        </>
    },
    {
        q: "Are there any dogs in the game? And if so... pettable or non-pettable?",
        a: <>
            <p>
                Yes, of course there’s a dog! Who in their right mind would even make a game without a dog these days? Let's be honest, that’d just be weird!
            </p>
            <p>
                Regarding pettability... hm... you just gonna have to find out for yourself!
            </p>
        </>
    },
    {
        q: "Let’s get real and personal... puppies or kittens?",
        a: <>
            <p>
                Ah yes, these are the great, existential questions of our time! But I’m afraid I can’t be seen to be taking sides.
            </p>
            <p>
                Plus, that’d almost be like asking regular or unlockable rider...
            </p>
        </>
    },
    {
        q: "When is the game coming out?",
        a: <>
            <p>
                The game is "coming soon", where "soon" is meant in the Silksong sense...
            </p>
            <p>
                It'll be ready when its ready.
            </p>
        </>
    },
    // {
    //     q: "",
    //     a: <>
    //     </>
    // },
    // {
    //     q: "",
    //     a: <>
    //     </>
    // },
];

// markup
const FaqQuestionsSection = () => {
    return (
        <div className="faq_section_questions">

            <div className="wrapper-wide">

                {items.map((item, index) => (
                    <div
                        className="item"
                        key={index}
                    >
                        <div className="item-q">
                            {item.q}
                        </div>
                        <div className="item-a">
                            {item.a}
                        </div>
                    </div>
                ))}

            </div>

        </div>
    )
}

export default FaqQuestionsSection